
const holidayDialog = {
  state: {
    hddState: false,
    hddIds: '',
    hddNames: ''
  },
  mutations: {
    SET_HDDSTATE: (state, hddState) => {
      state.hddState = hddState
    },
    SET_HDDIDS: (state, hddIds) => {
      state.hddIds = hddIds
    },
    SET_HDDNAMES: (state, hddNames) => {
      state.hddNames = hddNames
    }
  
  },
  actions: {
  }
}

export default holidayDialog
